import { createSelector } from 'reselect';

import { selectRequiredPrivacyCenter } from '@main/privacy-center/src/containers/App/selectors';

/**
 * The support email
 */
export const selectSupportEmail = createSelector(
  selectRequiredPrivacyCenter,
  (privacyCenter) => privacyCenter.supportEmail,
);
